<template>
  <transition name="scroll-to-top-fade">
    <div v-show="visible" class="tool-btn-box">
      <button class="tool-btn scroll-to-top" type="button" aria-label="回到顶部" @click="backToTop">
        <RocketOutlined style="color: #53a9e9" />
      </button>
    </div>
  </transition>
</template>

<script setup>
import { RocketOutlined } from "@antdv-next/icons";
import { backToTop, getScrollContainer } from "@/utils/util.js";

const props = defineProps({
  threshold: {
    type: Number,
    default: 240
  }
});

const visible = ref(false);
let scrollTarget = null;

function getScrollTop() {
  if (scrollTarget) {
    return scrollTarget.scrollTop;
  }
  return window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
}

function updateVisible() {
  visible.value = getScrollTop() > props.threshold;
}

onMounted(() => {
  scrollTarget = getScrollContainer();
  const listenerTarget = scrollTarget || window;
  listenerTarget.addEventListener("scroll", updateVisible, { passive: true });
  updateVisible();
});

onBeforeUnmount(() => {
  const listenerTarget = scrollTarget || window;
  listenerTarget.removeEventListener("scroll", updateVisible);
});
</script>

<style scoped lang="less">
.scroll-to-top {
  padding: 0;
  border: 0;
}

.scroll-to-top-fade-enter-active,
.scroll-to-top-fade-leave-active {
  transition:
    opacity 0.18s ease,
    transform 0.18s ease;
}

.scroll-to-top-fade-enter-from,
.scroll-to-top-fade-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
